/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { LinkedInConnectResponseCheckpointType } from './linkedInConnectResponseCheckpointType';
import type { LinkedInConnectResponseStatus } from './linkedInConnectResponseStatus';

export interface LinkedInConnectResponse {
  status: LinkedInConnectResponseStatus;
  linkedin_account_id: string;
  checkpoint_type?: LinkedInConnectResponseCheckpointType;
  checkpoint_platform?: string | null;
  checkpoint_expires_at?: string | null;
  qr_code_data_url?: string | null;
}
